export default "dist/images/66f4b86d86164fc117bd6d648e4eaa6f.png";